import React, { useContext } from "react";
import HPLogo from "./hrvatskaPosta-logo.png";
import PostaInfo from "./postaInfo-icon.png";
import Line from "../../common/line/Line";
import { Row, Column } from "../../common/columns";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../common/user/UserContext";
import { ThemeContext } from "../../common/theme/ThemeContext";
import DitLogo from "../../layout/footer/dokit-logo.png";
import BurgerMenu from "../header/menu/BurgerMenu";
import Logo from "../header/menu/Logo";

function Footer() {
  const { t } = useTranslation();
  const user = useContext(UserContext);
  const theme = useContext(ThemeContext);

  // theme.footerVersion = "v2";

  if (theme.footer === true) {
    return (
      <footer className="hero-foot">
        {
          theme.footerVersion === "v1" ? <Line height={8} color={theme.lineColor} /> : null
          // <Line height={23} color={theme.lineColor} />
        }
        <div className="p-3 has-background-black">
          {theme.footerVersion === "v1" ? (
            <Row>
              <Column className="is-4 has-text-right-desktop has-text-centered-touch">
                <img src={PostaInfo} alt="PostaInfo" />
              </Column>
              <Column className="is-2 has-text-white has-text-right-desktop has-text-centered-touch">
                <ul>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.instructions}
                    >
                      {t("userSupport.instructions")}
                    </a>
                  </li>
                  <li>{t("userSupport.title").toUpperCase()}</li>
                  <li>
                    <a
                      className={`is-link has-text-${theme.iconColor} has-background-black`}
                      href={`tel:+${t("userSupport.tel")}`}
                    >
                      {t("userSupport.tel")}
                    </a>
                  </li>
                </ul>
              </Column>
              <hr className={`has-background-${theme.lineColor} is-hidden-desktop`} />
              <Column className="is-2 has-text-white has-text-left-desktop has-text-centered-touch">
                <ul>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.usageTerms}
                    >
                      {t("userSupport.usageTerms")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.faq}
                    >
                      {t("userSupport.FAQ")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.contact}
                    >
                      {t("userSupport.contact")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        user.applicationConfiguration.externalLinks.userSupport
                          .generalTermsAndPrices
                      }
                    >
                      {t("userSupport.generalTermsAndPrices")}
                    </a>
                  </li>
                </ul>
              </Column>
              <Column className="is-4 has-text-left-desktop has-text-centered-touch">
                <img src={HPLogo} alt="HPLogo" />
              </Column>
            </Row>
          ) : (
            <>
              {/* <Row className="is-justify-content-center"> */}
              <Row className={`is-justify-content-space-between has-background-${theme.infoDark}`}>
                {/* <Column className="is-4 has-text-right-desktop has-text-centered-touch">
                <img src={HPLogo} alt="PostaInfo" />
              </Column> */}
                {/* Placeholder div for space-between */}
                <div style={{ marginLeft: "150px" }}></div>
                <Column className="is-5 has-text-white has-text-left-desktop has-text-centered-touch">
                  <ul style={{ marginTop: "5px" }} className="level">
                    <li>
                      <a
                        className="is-link has-text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                        // href={user.applicationConfiguration.externalLinks.userSupport.usageTerms}
                        href="#"
                      >
                        {t("userSupport.usageTerms")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="is-link has-text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                        // href={user.applicationConfiguration.externalLinks.userSupport.faq}
                        href="#"
                      >
                        {t("userSupport.FAQ")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="is-link has-text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                        // href={user.applicationConfiguration.externalLinks.userSupport.contact}
                        href="#"
                      >
                        {t("userSupport.contact")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="is-link has-text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                        // href={
                        //   user.applicationConfiguration.externalLinks.userSupport
                        //     .generalTermsAndPrices
                        // }
                        href="#"
                      >
                        {t("userSupport.generalTermsAndPrices")}
                      </a>
                    </li>
                  </ul>
                </Column>
                <div>
                  <img
                    style={{ width: "56px", height: "56px", marginRight: "75px" }}
                    src={DitLogo}
                    alt="logo"
                  />
                </div>
              </Row>
            </>
          )}
        </div>
        <div className="has-background-black">
          <div
            style={{ backgroundColor: "#ededed" }}
            className="has-text-centered has-text-black has-text-weight-bold pt-3 pb-3"
          >
            © Dokument IT d.o.o. | 2023.
          </div>
        </div>
      </footer>
    );
  } else {
    return (
      <footer className="hero-foot">
        <div className="has-background-black">
          <div className="has-text-centered has-text-white has-text-weight-bold">
            ©2023 All rights reserved by Dokument IT d.o.o.
          </div>
        </div>
        <Line height={8} color={theme.iconColor} />
      </footer>
    );
  }
}

export default Footer;
